import React from 'react'
import classnames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(theme => ({
  errorContainer: {
    marginTop: theme.spacing(2),
  },
  errorText: {
    color: theme.palette.error.main,
  },
}))

const FormErrors = ({
  errors,
  className,
}) => {

  const classes = useStyles()

  if(Object.keys(errors).length <= 0) return null
 
  return (
    <div className={ classnames(classes.errorContainer, className) }>
      <Typography className={ classes.errorText }>
        There are errors in the form:
      </Typography>
      <ul className={ classes.errorText }>
        {
          Object.keys(errors).map((key, i) => (
            <li key={ i }>
              <Typography className={ classes.errorText }>
                { key }: { errors[key] }
              </Typography>
            </li>
          ))
        }
      </ul>
    </div> 
  )
}

export default FormErrors